import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from "react";
import { observer } from "mobx-react";
import { __ } from "../../../../utils";
import { Tabs, Spin, Popover } from "antd";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import { useStores } from "../../../../store";
import { CookieGroupEditForm } from "..";
import { CookieGroupTabHeadline } from ".";
import { useCookieGroupTabSortable } from "../../../../hooks";
import { ConfigHintModal } from "../../../";
import { useAsyncEffect } from "@devowl-wp/react-utils";
const CookieGroupsTabLayout = observer(()=>{
    const { cookieStore, optionStore } = useStores();
    const { essentialGroup, groups: { sortedGroups } } = cookieStore;
    const params = useParams();
    const { pathname } = useLocation();
    const isTcfRoute = pathname.indexOf("tcf-vendors") > -1;
    const [isAddNewVisible, setIsAddNewVisible] = useState(false);
    const tab = (isTcfRoute ? "tcf-vendors" : params.cookieGroup) || (essentialGroup == null ? void 0 : essentialGroup.key.toString());
    const isRootQuery = isTcfRoute ? false : !params.cookieGroup;
    const navigate = useNavigate();
    const { isBannerActive, isOnlyRcbCookieCreated, isTcf } = optionStore;
    const { groups } = cookieStore;
    const ref = useCookieGroupTabSortable(!isRootQuery);
    const redirectToEssentialGroupIfRoot = useCallback(()=>{
        // Initially replace current url when fetching root instead of "Essential"
        if (isRootQuery && essentialGroup) {
            navigate(isTcf ? "tcf-vendors" : essentialGroup.key.toString(), {
                replace: true
            });
        }
    }, [
        isRootQuery,
        essentialGroup,
        isTcf
    ]);
    useAsyncEffect(async (param)=>{
        let { aborted } = param;
        if (!essentialGroup) {
            await cookieStore.fetchGroups();
            if (!aborted()) {
                redirectToEssentialGroupIfRoot();
            }
        }
    }, [
        essentialGroup,
        redirectToEssentialGroupIfRoot,
        isTcf
    ]);
    // Avoid flickering when we click the "Cookies" tab again
    useEffect(()=>{
        redirectToEssentialGroupIfRoot();
    }, [
        redirectToEssentialGroupIfRoot
    ]);
    return isRootQuery || sortedGroups.length === 0 ? /*#__PURE__*/ _jsx(Spin, {
        style: {
            margin: "auto",
            marginTop: 15
        }
    }) : /*#__PURE__*/ _jsx(Spin, {
        spinning: groups.busy,
        children: /*#__PURE__*/ _jsxs("div", {
            ref: ref,
            children: [
                !isBannerActive && !isOnlyRcbCookieCreated && /*#__PURE__*/ _jsx("div", {
                    className: "notice notice-warning inline below-h2 notice-alt",
                    style: {
                        margin: "10px 0 0 0"
                    },
                    children: /*#__PURE__*/ _jsxs("p", {
                        children: [
                            __("The cookie banner is globally deactivated in the settings and is therefore not displayed on your website."),
                            " ",
                            "• ",
                            /*#__PURE__*/ _jsx("a", {
                                href: "#/settings",
                                children: __("Enable now")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Tabs, {
                    destroyInactiveTabPane: true,
                    activeKey: tab,
                    tabBarExtraContent: [
                        "tcf-vendors"
                    ].indexOf(tab) === -1 && /*#__PURE__*/ _jsx(Popover, {
                        open: isAddNewVisible,
                        content: /*#__PURE__*/ _jsx(CookieGroupEditForm, {
                            onClose: ()=>setIsAddNewVisible(false)
                        }),
                        placement: "bottomRight",
                        children: /*#__PURE__*/ _jsx("button", {
                            className: "button button-primary button-large",
                            style: {
                                marginTop: 6
                            },
                            onClick: ()=>setIsAddNewVisible(!isAddNewVisible),
                            children: __("Add group")
                        })
                    }),
                    onTabClick: (key)=>{
                        navigate(`/cookies/${key}`);
                    },
                    items: [
                        isTcf && {
                            key: "tcf-vendors",
                            label: __("TCF Vendors"),
                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Outlet, {}),
                                    /*#__PURE__*/ _jsx(ConfigHintModal, {
                                        identifier: "tcf-vendor"
                                    })
                                ]
                            })
                        },
                        isTcf && {
                            key: "tcf-vendors-split",
                            label: /*#__PURE__*/ _jsx("span", {
                                children: "•"
                            }),
                            disabled: true,
                            children: /*#__PURE__*/ _jsx("div", {})
                        },
                        ...sortedGroups.map((group)=>({
                                key: group.key.toString(),
                                label: /*#__PURE__*/ _jsx(CookieGroupTabHeadline, {
                                    group: group
                                }),
                                children: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Outlet, {}),
                                        /*#__PURE__*/ _jsx(ConfigHintModal, {
                                            identifier: "cookie"
                                        })
                                    ]
                                })
                            }))
                    ].filter(Boolean)
                })
            ]
        })
    });
});
export { CookieGroupsTabLayout };
